import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const guarantees = ['Descarga instantánea', 'Acceso de por vida', 'Garantía de 7 días'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-bone" data-id="element-113" data-mp="4m8mecr76rkx">
      <div className="bg-court absolute inset-0" aria-hidden="true" data-id="element-114" data-mp="4jvup7vn12uo" />

      <div className="relative mx-auto max-w-5xl px-5 pb-16 pt-6 text-center lg:pb-20" data-id="element-115" data-mp="128yz6bncnty4">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="inline-flex max-w-full items-center gap-1.5 whitespace-nowrap rounded-full border-2 border-ink bg-white px-3 py-1.5 sm:gap-2.5 sm:px-4 sm:py-2" data-id="element-116" data-mp="xbpaiy7sbmbc">
          <span className="flex items-center gap-0.5 text-brand" aria-hidden="true" data-id="element-117" data-mp="382ffjpbzl6fg">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-2.5 w-2.5 fill-current sm:h-3.5 sm:w-3.5" data-id="element-118" data-mp="3j924znc7pov0" data-mpi={index} />)}
          </span>
          <span className="text-[9px] font-extrabold uppercase tracking-[0.08em] text-ink sm:text-xs sm:tracking-[0.12em]" data-id="element-119" data-mp="3o6u87dib4xei">
            4.9/5 · +1.500 docentes en Hispanoamérica
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: EASE
      }} className="balance mx-auto mt-7 max-w-3xl font-display text-[2.3rem] leading-[0.97] tracking-[-0.015em] text-ink sm:text-[3.2rem] lg:text-[4rem]" data-id="element-120" data-mp="3ebiqqnfilc32">
          Resuelve un año entero de clases de Inglés en solo{' '}
          <span className="relative inline-block whitespace-nowrap text-brand" data-id="element-121" data-mp="2hjf81tavgibr">
            5 minutos
            <span className="absolute inset-x-0 -bottom-1 h-[0.12em] rounded-full bg-volt" aria-hidden="true" data-id="element-122" data-mp="2lkiiu1e2bo64" />
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: EASE
      }} className="balance mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-ink/70 sm:text-base" data-id="element-123" data-mp="s3mb9x0ezovq">
          <span className="font-bold text-ink" data-id="element-124" data-mp="deyk02xlq1bl">
            Basta de quemar tus domingos planificando.
          </span>{' '}
          Descarga, imprime y entra al aula con la secuencia didáctica lista
          para ejecutar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease: EASE
      }} className="relative mx-auto mt-6 w-full max-w-sm" data-id="element-125" data-mp="1126oiin7h6ck">
          <img src="https://cdn.magicpatterns.com/uploads/3Jkmpd1SvHvtYCSjcH2cnk/7753beb6-6904-43f6-90c0-182999dd0185.webp" alt="El Kit INGLES LISTO: los doce volúmenes graduados, la plataforma digital en monitor, tablet y celular, y los cinco bonos incluidos" className="block w-full" data-id="element-126" data-mp="3lqm4w5d59hy3" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.22,
        ease: EASE
      }} className="mx-auto mt-5 max-w-2xl text-sm font-semibold leading-relaxed text-ink/60" data-id="element-127" data-mp="269zfrlmtwjkp">
          12 Volúmenes por Niveles de Progresión + Master Plan de Evaluación + 5
          Bonos Reales.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.26,
        ease: EASE
      }} className="mt-8 flex flex-col items-center" data-id="element-128" data-mp="2p0h83p3r1d5j">
          <CtaButton label="¡Quiero mi Kit ahora!" href="#offer" className="w-full max-w-xl" data-id="element-129" data-mp="uo0svysz6ooj" />

          <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-130" data-mp="zm2o1i3oeegd">
            {guarantees.map(item => <li key={item} className="flex items-center gap-2 text-sm font-bold text-ink/75" data-id="element-131" data-mp="4d78j9jo1k3h">
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-volt" data-id="element-132" data-mp="3vk1ixy09g0x8">
                  <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-133" data-mp="e77grka8v5gf" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}